import { AdminWorkMessages } from '@components/admin/AdminWorkMessages';
import * as Admin from '@store/admin';
import { connect } from 'react-redux';
import type { ApplicationState } from '../../store';

export default connect(
    (state: ApplicationState) => ({
        ...Admin.plainActions,
    }),
    Admin.actionCreators,
)(AdminWorkMessages as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
